import { TripPointType } from './trip';

export const TripIconSet = Symbol('TripIconSet');
export interface TripIconSet {
  getTripIconClass(type: TripPointType): string;
}
